import type { IconSvgObject } from './types';

const HangoutIcon: IconSvgObject = [
  ["path", { d: "M11.883 2C7.045 2.00068 3.0007 6.04639 3 10.75C3 15.27 7.23514 18.82 11.883 18.82V22C17.2791 19.34 21 15.1688 21 10.75C21 5.98 16.7893 2 11.883 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 12C17 13 16 14 15.5 14V12L13 12V8H17V12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 12C10.5 13 9.5 14 9 14V12L6.5 12V8H10.5V12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HangoutIcon;
